import { TenantCustomer } from '~/tenants/common/TenantPersona';

export default class DemoCustomer extends TenantCustomer {}
